
export const privatePayment = [
  {
    path: '/escolha-pagamento',
    name: 'payment-choice',
    component: () => import('@/views/payment/PaymentChoices.vue'),
    meta: {
      header: {
        hidePreviousBtn: false,
        title: 'Convênio',
      },
    },
  },
  {
    path: '/carregando-pagamento',
    name: 'payment-pre-loading',
    component: () => import('@/views/payment/PaymentPreLoading.vue'),
    meta: {
      header: {
        hidePreviousBtn: true,
        title: 'Pagamento',
      },
    },
  },
  {
    path: '/pagamento-cartao',
    name: 'credit-card-payment',
    component: () => import('@/views/payment/PaymentCard.vue'),
    meta: {
      header: {
        title: 'Dados do cartão',
      },
    },
  },
  {
    path: '/resumo-pagamento',
    name: 'payment-resume',
    component: () => import('@/views/payment/PaymentResume.view.vue'),
    meta: {
      header: {
        hidePreviousBtn: true,
        title: 'Pagamento'
      },
    },
  },
  {
    path: '/forma-de-pagamento',
    name: 'payment-methods',
    component: () => import('@/views/payment/PaymentMethod.view.vue'),
    meta: {
      header: {
        title: 'Forma de Pagamento',
      },
    },
  },
  {
    path: '/pagamento-pix',
    name: 'pix-payment',
    component: () => import('@/views/payment/PaymentPix.vue'),
    meta: {
      header: {
        title: 'Pagamento com Pix',
      },
    },
  },
  {
    path: '/pagamento-pix-confirmado',
    name: 'pix-payment-confirmed',
    component: () => import('@/views/payment/PaymentPixSuccess.vue'),
    meta: {
      header: {
        title: 'Pagamento com Pix',
      },
    },
  },
  {
    path: '/pagamento-pix-erro',
    name: 'pix-payment-error',
    component: () => import('@/views/payment/PaymentPixDenied.vue'),
    meta: {
      header: {
        title: 'Pagamento com Pix',
      },
    },
  },
  {
    path: '/pagamento-pix-erro-codigo',
    name: 'pix-payment-error-code',
    component: () => import('@/views/payment/PaymentPixErrorCode.vue'),
    meta: {
      header: {
        title: 'Pagamento com Pix',
      },
    },
  },
];
